<template>
    <section class="legal-section">
        <div class="container">
            <h1 class="legal-title">Privacy Policy</h1>
            <p class="legal-intro">
                This Privacy Policy explains how HarashFit collects, uses, and protects your personal data when you access or use our website (harashfit.com) and associated services. We are committed to handling your information responsibly and in accordance with applicable data protection laws.
            </p>

            <h2>1. Information We Collect</h2>
            <ul>
                <li><strong>Personal Information:</strong> Name, email address, phone number, and any data you provide via forms, subscriptions, or communication.</li>
                <li><strong>Payment Information:</strong> If you purchase a subscription, payment details are collected and processed securely by our third-party payment providers (we do not store this data ourselves).</li>
                <li><strong>Usage Data:</strong> IP address, browser type, pages visited, time and date of visit, device information – collected via tools like Google Analytics and Meta Pixel.</li>
                <li><strong>Cookies:</strong> We use cookies to enhance functionality and analyze traffic. Please see our <router-link to="/cookies">Cookie Policy</router-link> for more details.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <ul>
                <li>To deliver and improve our training services and website features.</li>
                <li>To manage subscriptions and user accounts.</li>
                <li>To communicate with you, including updates and promotional emails (with your consent).</li>
                <li>To understand usage patterns and optimize performance.</li>
                <li>To comply with legal obligations where applicable.</li>
            </ul>

            <h2>3. Sharing Your Data</h2>
            <p>
                We do not sell or rent your personal data. We may share it with:
            </p>
            <ul>
                <li>Trusted payment providers to process transactions securely.</li>
                <li>Analytics and advertising tools (such as Google Analytics, Meta Pixel) for performance insights and marketing purposes.</li>
                <li>Partners or service providers acting on our behalf, under strict confidentiality obligations.</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>
                We implement appropriate technical and organizational measures to protect your data. While we strive to secure your information, no method of transmission over the internet is 100% secure.
            </p>

            <h2>5. Your Rights</h2>
            <p>You may have the right, depending on your jurisdiction, to:</p>
            <ul>
                <li>Access the personal data we hold about you.</li>
                <li>Request correction or deletion of your data.</li>
                <li>Withdraw consent for data processing (where consent is the basis).</li>
                <li>Request restriction or object to certain types of processing.</li>
            </ul>
            <p>
                To exercise your rights, please contact us using the details below.
            </p>

            <h2>6. Data Retention</h2>
            <p>
                We retain your data only as long as necessary for the purposes outlined in this policy or as required by applicable laws.
            </p>

            <h2>7. International Transfers</h2>
            <p>
                We operate globally, and your data may be processed in or transferred to countries outside your location. Where required, we ensure adequate safeguards are in place to protect your data.
            </p>

            <h2>8. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy periodically. Any changes will be posted on this page with the updated effective date.
            </p>

            <h2>9. Contact</h2>
            <p>
                If you have any questions or requests regarding this Privacy Policy, please contact us:<br />
                <strong>Email:</strong> info@harashfit.com<br />
                <strong>Phone:</strong> +962 7 9060 6181<br />
                <strong>Address:</strong> Amman, Jordan
            </p>
        </div>
    </section>
</template>


<style scoped>
.legal-section {
    padding: 10px 20px;
    color: #f0f0f0;
    min-height: 100vh;
    line-height: 1.7;
    font-size: 15px;
}

.container {
    max-width: 900px;
    margin: auto;
}

.legal-title {
    font-size: 36px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 20px;
    text-align: center;
}

.legal-intro {
    font-size: 16px;
    margin-bottom: 30px;
    color: #dddddd;
}

h2 {
    margin-top: 32px;
    font-size: 22px;
    color: #ff5555;
}

ul {
    margin-left: 20px;
    margin-top: 10px;
    color: #cccccc;
}

li {
    margin-bottom: 12px;
}
</style>